import Vue from "vue";
import Vuex from "vuex";

// import firebase from "./firebase/index";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    value: false,
    menuLinks: [
      {
        title: "Development",
        link: "/development"
      },
      {
        title: "Portfolio",
        link: "/portfolio"
      },
      {
        title: "Pricing",
        link: "/pricing"
      },
      {
        title: "Team",
        link: "/team"
      },
      {
        title: "+1 859 684 0646",
        icon: "phone",
        link: "/",
        type: "button"
      }

    ],

    //   demo_content:
    //     "Qui voluptatem ut optio commodi aut consequatur omnis. Quis optio nulla laboriosam facere enim magnam. Dolores enim reiciendis vel autem. Nesciunt est in asperiores.",
    //   demo_heading: "Autem excepturi quod dicta ipsam",
    //   demo_short_title: "Ratione Occaecati",
    //   reviews: [
    //     {
    //       reviewer: "John Doe",
    //       review:
    //         "Qui voluptatem ut optio commodi aut consequatur omnis. Quis optio nulla laboriosam facere enim magnam."
    //     },

    //     {
    //       reviewer: "Jane Doe",
    //       review:
    //         "Qui voluptatem ut optio commodi aut consequatur omnis. Quis optio nulla laboriosam facere enim magnam."
    //     }
    //   ],

    //   case_study_data: {
    //     seo: [
    //       {
    //         projectName: "AMP Honors Program",
    //         featuredImage: "https://via.placeholder.com/400x300/?text=seo",
    //         screenshot:
    //           "https://via.placeholder.com/800x1000/?text=screenshot_demo",
    //         content:
    //           "Qui voluptatem ut optio commodi aut consequatur omnis. Quis optio nulla laboriosam facere enim magnam. Dolores enim reiciendis vel autem. Nesciunt est in asperiores.",
    //         infoContent: {
    //           client: "AMP",
    //           link: "https://www.amphonorsprogram.com",
    //           services: [
    //             "Technical Architecture",
    //             "Web Development",
    //             "Google Maps Integration"
    //           ]
    //         },
    //         slug: "amp"
    //       },

    //       {
    //         projectName: "Qui Voluptatem",
    //         featuredImage: "https://via.placeholder.com/400x300/?text=seo",
    //         screenshot:
    //           "https://via.placeholder.com/800x1000/?text=screenshot_demo",
    //         content:
    //           "Qui voluptatem ut optio commodi aut consequatur omnis. Quis optio nulla laboriosam facere enim magnam. Dolores enim reiciendis vel autem. Nesciunt est in asperiores.",
    //         infoContent: {
    //           client: "AMP",
    //           link: "https://www.amphonorsprogram.com",
    //           services: [
    //             "Technical Architecture",
    //             "Web Development",
    //             "Google Maps Integration"
    //           ]
    //         },
    //         slug: "amp2"
    //       }
    //     ],

    //     ecommerce: [
    //       {
    //         projectName: "Commodi Aut Consequatur",
    //         featuredImage: "https://via.placeholder.com/400x300/?text=ecommerce",
    //         screenshot:
    //           "https://via.placeholder.com/800x1000/?text=screenshot_demo",
    //         content:
    //           "Qui voluptatem ut optio commodi aut consequatur omnis. Quis optio nulla laboriosam facere enim magnam. Dolores enim reiciendis vel autem. Nesciunt est in asperiores.",
    //         infoContent: {
    //           client: "AMP",
    //           link: "https://www.amphonorsprogram.com",
    //           services: [
    //             "Technical Architecture",
    //             "Web Development",
    //             "Google Maps Integration"
    //           ]
    //         },
    //         slug: "ecommerce1"
    //       }
    //     ]
    //   }
    },

//   getters: {
//     value: state => {
//       return state.value;
//     },
//     getCaseStudiesByCategory: state => category => {
//       var cs = state.case_study_data[ category ];
//       return state.case_study_data[ category ];
//     },

//     getCaseStudiesAll: state => {
//       return state.case_study_data;
//     },

//     getCaseStudy: state => (category, slug) => {
//       var data = false;

//       state.case_study_data[ category ].forEach(element => {
//         if (element.slug === slug) {
//           data = element;
//           return;
//         }
//       });

//       return data;
//     }
//   },

//   mutations: {
//     query: state => {
//       let val = {};

//       firebase
//         .firestore()
//         .collection("case_study")
//         .get()
//         .then(querySnapshot => {
//           state.value = true;
//           querySnapshot.forEach(doc => {
//             console.log(`${doc.id} => ${doc.data()} First query`);
//             val.id = doc.id;
//             val.data = doc.data();
//           });
//           // console.log(querySnapshot, "Firebase Results");
//         });

//       return val;
//     }
//   },

//   actions: {
//     finalQuery: ({ commit }, state) => {
//       commit("query");
//     }
//   }
});
